import { CanDeactivateFn } from '@angular/router';

export const authBlockGuard: CanDeactivateFn<unknown> = (component, currentRoute, currentState, nextState) => {
  return true;
};
